document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.PDP_bundle_object_feel_accordian_dropdown_container')
        .forEach(container => {

            const menu = container.querySelector('.PDP_bundle_object_feel_accordian_dropdown_menu');
            const tabs = menu?.querySelectorAll('.PDP_bundle_object_feel_accordian_tab') || [];
            const bg = menu?.querySelector('.tab_background_new');
            const selectedText = container.querySelector('.selected_product');

            if (!tabs.length || !bg || !selectedText) return;

            function moveBgToTab(tab) {
                const tabRect = tab.getBoundingClientRect();
                const menuRect = menu.getBoundingClientRect();
                const isLast = tab === tabs[tabs.length - 1];

                let offset = tabRect.left - menuRect.left;
                if (isLast) offset -= 4;

                bg.style.width = `${tabRect.width}px`;
                bg.style.transform = `translateX(${offset}px)`;
            }

            function activateTab(tab) {
                tabs.forEach(t => t.classList.remove('active'));
                tab.classList.add('active');

                // 🔥 Replace selected product text
                selectedText.innerHTML = tab.innerHTML;

                const dataObjectTab = tab.dataset.objectTab;
                document.querySelectorAll('.PDP_object_feel_accordion_main_new')
                    .forEach(section =>
                        section.classList.toggle('active', section.id === dataObjectTab)
                    );

                moveBgToTab(tab);
            }

            tabs.forEach(tab => {
                tab.addEventListener('click', () => activateTab(tab));
            });

            // Default active tab (matches Liquid first product)
            activateTab(tabs[0]);

            window.addEventListener('resize', () => {
                const activeTab = menu.querySelector('.PDP_bundle_object_feel_accordian_tab.active');
                if (activeTab) moveBgToTab(activeTab);
            });

        });
});


// Drop down (mobile only)
if (window.innerWidth < 750) {
    document.querySelectorAll('.PDP_bundle_object_feel_accordian_dropdown')
        .forEach(dropdown => {

            dropdown.addEventListener('click', function () {
                this.classList.toggle('active');
            });

            dropdown.querySelectorAll('.PDP_bundle_object_feel_accordian_tab')
                .forEach(tab => {
                    tab.addEventListener('click', function (e) {
                        e.stopPropagation(); 
                        dropdown.classList.remove('active');
                    });
                });
        });
}


